
import { getSearchProjectId } from '../../project';
import { getActions } from '../sagas';

 /**
 * Options affecting client behavior in search execution.
 *
 * @typedef {Object} MultSceneForApp~Search~Commands~DoSearchOptions
 * @property {Boolean} [silent] - flag for silent execution, if=true UI does not respond to execution
 * @property {string} [desc] - identify each execution of search
 */

/**
 * Command `search.doSearch`
 *
 * @typedef {Object} MultSceneForApp~Search~Commands~DoSearch
 * @property {string} command - name of command, has value `search.doSearch`
 * @property {string} queryId - ID of search query definition
 * @property {Object} params - search parameters
 * @property {MultSceneForApp~Search~Commands~DoSearchOptions} [clientOptions] - options affecting client behavior
 */
function doSearch(params, dispatch, store) {
    let projectId = getSearchProjectId(store.getState().project);
    const doSearch = getActions(dispatch).doSearch;

    doSearch(projectId, params.queryId, params.params, params.clientOptions, false, 'SET');
}

export default {
    name: 'search.doSearch',
    execute: doSearch
}
